import React from 'react';
import { AlertCircleIcon, ClockIcon, BarChart3Icon } from 'lucide-react';
export const DebtDetails = () => {
  return <div className="space-y-8" data-id="element-700">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-701">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-702">
          <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-703">
            Deuda Total
          </h3>
          <p className="text-3xl font-bold text-blue-600" data-id="element-704">S/ 12,450.00</p>
          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-705">
            <div className="flex justify-between items-center" data-id="element-706">
              <span className="text-sm text-gray-500" data-id="element-707">Capital</span>
              <span className="text-sm font-medium" data-id="element-708">S/ 10,000.00</span>
            </div>
            <div className="flex justify-between items-center mt-2" data-id="element-709">
              <span className="text-sm text-gray-500" data-id="element-710">Intereses</span>
              <span className="text-sm font-medium" data-id="element-711">S/ 2,450.00</span>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-712">
          <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-713">
            Días en Mora
          </h3>
          <div className="flex items-center" data-id="element-714">
            <ClockIcon className="h-8 w-8 text-red-500 mr-3" data-id="element-715" />
            <p className="text-3xl font-bold text-red-600" data-id="element-716">120 días</p>
          </div>
          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-717">
            <div className="flex justify-between items-center" data-id="element-718">
              <span className="text-sm text-gray-500" data-id="element-719">Fecha Vencimiento</span>
              <span className="text-sm font-medium" data-id="element-720">15/11/2023</span>
            </div>
            <div className="flex justify-between items-center mt-2" data-id="element-721">
              <span className="text-sm text-gray-500" data-id="element-722">Última Actividad</span>
              <span className="text-sm font-medium" data-id="element-723">10/01/2024</span>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-724">
          <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-725">Categoría</h3>
          <div className="flex items-center" data-id="element-726">
            <AlertCircleIcon className="h-8 w-8 text-yellow-500 mr-3" data-id="element-727" />
            <p className="text-xl font-bold text-yellow-600" data-id="element-728">Riesgo Medio</p>
          </div>
          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-729">
            <div className="flex justify-between items-center" data-id="element-730">
              <span className="text-sm text-gray-500" data-id="element-731">Score Crediticio</span>
              <div className="flex items-center" data-id="element-732">
                <span className="text-sm font-medium mr-1" data-id="element-733">650</span>
                <BarChart3Icon className="h-4 w-4 text-yellow-500" data-id="element-734" />
              </div>
            </div>
            <div className="flex justify-between items-center mt-2" data-id="element-735">
              <span className="text-sm text-gray-500" data-id="element-736">Probabilidad Pago</span>
              <span className="text-sm font-medium" data-id="element-737">65%</span>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-738">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-739">
          Detalle de Deuda
        </h2>
        <div className="overflow-x-auto" data-id="element-740">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-741">
            <thead className="bg-gray-50" data-id="element-742">
              <tr data-id="element-743">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-744">
                  Concepto
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-745">
                  Fecha Emisión
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-746">
                  Fecha Vencimiento
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-747">
                  Capital
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-748">
                  Intereses
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-749">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-750">
              <tr data-id="element-751">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-752">
                  Cuota 1
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-753">
                  15/08/2023
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-754">
                  15/09/2023
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-755">
                  S/ 2,500.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-756">
                  S/ 400.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-757">
                  S/ 2,900.00
                </td>
              </tr>
              <tr data-id="element-758">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-759">
                  Cuota 2
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-760">
                  15/09/2023
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-761">
                  15/10/2023
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-762">
                  S/ 2,500.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-763">
                  S/ 350.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-764">
                  S/ 2,850.00
                </td>
              </tr>
              <tr data-id="element-765">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-766">
                  Cuota 3
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-767">
                  15/10/2023
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-768">
                  15/11/2023
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-769">
                  S/ 2,500.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-770">
                  S/ 300.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-771">
                  S/ 2,800.00
                </td>
              </tr>
              <tr data-id="element-772">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-773">
                  Cuota 4
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-774">
                  15/11/2023
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-775">
                  15/12/2023
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-776">
                  S/ 2,500.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-777">
                  S/ 250.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-778">
                  S/ 2,750.00
                </td>
              </tr>
            </tbody>
            <tfoot className="bg-gray-50" data-id="element-779">
              <tr data-id="element-780">
                <td colSpan={3} className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 text-right" data-id="element-781">
                  Total:
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-782">
                  S/ 10,000.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-783">
                  S/ 1,300.00
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-784">
                  S/ 11,300.00
                </td>
              </tr>
              <tr data-id="element-785">
                <td colSpan={3} className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 text-right" data-id="element-786">
                  Intereses por Mora:
                </td>
                <td colSpan={3} className="px-6 py-4 whitespace-nowrap text-sm font-medium text-red-600" data-id="element-787">
                  S/ 1,150.00
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>;
};